import { NOTIFICATION_VISITED, NEW_NOTIFICATION, GET_DISTRIBUTOR_ALL_CATEGORY_INBOX, GET_DISTRIBUTOR_INFO_CATEGORY_INBOX, GET_DISTRIBUTOR_ORDER_CATEGORY_INBOX, GET_DISTRIBUTOR_COMPLAINT_CATEGORY_INBOX, GET_DISTRIBUTOR_OTHER_CATEGORY_INBOX } from '../../../Types'
import _ from 'lodash'
const initialState = {
  handlerNotificationObject: null,
  newNotificationData: null,
  ticketsData: {
    infoTickets: [],
    orderTickets: [],
    complaintTickets: [],
    otherTickets: []
  }
}
const DistributorInboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_VISITED: {
      const handlerObject = action.payload;

      const updateTicketList = (ticketKey) => {
        const list = [
          ...(state?.ticketsData?.[ticketKey]?.dataList || [])
        ];

        const index = list.findIndex(
          (h) => h.handlerId == handlerObject?.handlerId
        );

        if (index !== -1) {
          list[index] = {
            ...list[index],
            notificationVisited: true,
          };
        }

        return {
          ...state,
          ticketsData: {
            ...state.ticketsData,
            [ticketKey]: {
              ...state.ticketsData?.[ticketKey],
              dataList: list,
            },
          },
        };
      };

      switch (handlerObject.handlerCategoryCode) {
        case "1":
          return updateTicketList("infoTickets");

        case "2":
          return updateTicketList("orderTickets");

        case "3":
          return updateTicketList("complaintTickets");

        case "4":
          return updateTicketList("otherTickets");

        default:
          return state;
      }
    }

    case NEW_NOTIFICATION:
      return {
        ...state,
        newNotificationData: action.payload,
      };

    case GET_DISTRIBUTOR_ALL_CATEGORY_INBOX:
      return {
        ...state,
        ticketsData: action?.payload,
      };

    case GET_DISTRIBUTOR_INFO_CATEGORY_INBOX:
      return {
        ...state,
        ticketsData: {
          ...state.ticketsData,
          infoTickets: action?.payload,
        },
      };

    case GET_DISTRIBUTOR_ORDER_CATEGORY_INBOX:
      return {
        ...state,
        ticketsData: {
          ...state.ticketsData,
          orderTickets: action?.payload,
        },
      };

    case GET_DISTRIBUTOR_COMPLAINT_CATEGORY_INBOX:
      return {
        ...state,
        ticketsData: {
          ...state.ticketsData,
          complaintTickets: action?.payload,
        },
      };

    case GET_DISTRIBUTOR_OTHER_CATEGORY_INBOX:
      return {
        ...state,
        ticketsData: {
          ...state.ticketsData,
          otherTickets: action?.payload,
        },
      };

    default:
      return state;
  }
};
export default DistributorInboxReducer
